import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const EditIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (

    <svg 
        id={id}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.13121 6.46447C4.0689 5.52678 5.34067 5 6.66675 5H18.3334C19.2539 5 20.0001 5.74619 20.0001 6.66667C20.0001 7.58714 19.2539 8.33333 18.3334 8.33333H6.66675C6.22472 8.33333 5.8008 8.50893 5.48824 8.82149C5.17568 9.13405 5.00008 9.55797 5.00008 10V33.3333C5.00008 33.7754 5.17568 34.1993 5.48824 34.5118C5.8008 34.8244 6.22472 35 6.66675 35H30.0001C30.4421 35 30.866 34.8244 31.1786 34.5118C31.4912 34.1993 31.6667 33.7754 31.6667 33.3333V21.6667C31.6667 20.7462 32.4129 20 33.3334 20C34.2539 20 35.0001 20.7462 35.0001 21.6667V33.3333C35.0001 34.6594 34.4733 35.9312 33.5356 36.8689C32.5979 37.8065 31.3262 38.3333 30.0001 38.3333H6.66675C5.34066 38.3333 4.0689 37.8065 3.13121 36.8689C2.19353 35.9312 1.66675 34.6594 1.66675 33.3333V10C1.66675 8.67392 2.19353 7.40215 3.13121 6.46447Z" 
            fill={iconColor}
            />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.3334 4.79781C32.8378 4.79781 32.3624 4.99471 32.012 5.34519L16.5051 20.8521L15.6241 24.3761L19.148 23.4951L34.6549 7.98817C35.0054 7.63769 35.2023 7.16233 35.2023 6.66668C35.2023 6.17102 35.0054 5.69567 34.6549 5.34519C34.3045 4.99471 33.8291 4.79781 33.3334 4.79781ZM29.6549 2.98817C30.6305 2.01256 31.9537 1.46448 33.3334 1.46448C34.7132 1.46448 36.0364 2.01256 37.012 2.98817C37.9876 3.96377 38.5357 5.28697 38.5357 6.66668C38.5357 8.04639 37.9876 9.36959 37.012 10.3452L21.1786 26.1785C20.965 26.3921 20.6974 26.5437 20.4043 26.6169L13.7377 28.2836C13.1697 28.4256 12.5689 28.2592 12.1549 27.8452C11.741 27.4312 11.5746 26.8304 11.7165 26.2625L13.3832 19.5958C13.4565 19.3027 13.608 19.0351 13.8216 18.8215L29.6549 2.98817Z"
            fill={iconColor}
            />
    </svg>
);

export { EditIcon };